import { POST } from '@/utils/axios'

export const addTranslation = async formData =>
  await POST('/user-translations/add-translation', formData, {
    useAuthorization: true
  })
